export default "__VITE_ASSET__cfd7ef60__"